import scenarioStatusSlice, { actions } from "./reducer";
import * as thunkActions from "./actions";
export const scenarioStatusActions = { ...actions, ...thunkActions };
export * as ScenarioStatusTypes from './types';
export default scenarioStatusSlice;
